<template>
  <div>
    <h4>Dados da Pessoa</h4>
    <table class="table table-bordered table-hover" role="grid">
      <tbody>
        <tr role="row" class="odd">
          <td>
            <b>Nome/Razão:</b>
          </td>
          <td>{{ pessoa.nome_razao }}</td>
        </tr>
        <tr role="row" class="odd">
          <td>
            <b>Cpf/Cnpj:</b>
          </td>
          <td>{{ pessoa.cpf_cnpj }}</td>
        </tr>
        <tr role="row" class="odd">
          <td>
            <b>Telefones:</b>
          </td>
          <td>
            {{ pessoa.telefone1 ? pessoa.telefone1 : '' }}
            {{ pessoa.telefone2 ? ' | ' + pessoa.telefone2 : '' }}
            {{ pessoa.tel_ref_comercial ? ' | ' + pessoa.tel_ref_comercial : '' }}
            {{ pessoa.tel_ref_pessoal ? ' | ' + pessoa.tel_ref_pessoal : '' }}
          </td>
        </tr>
      </tbody>
    </table>

    <h4 class="mt-40">Novo Agendamento</h4>
    <div class="row">
      <div class="col-sm-8 col-lg-9">
        <div :class="{'form-group': true, 'has-error':errors.has('descricao') }">
          <label for="descricao">Descrição</label>
          <input
            class="form-control"
            type="text"
            name="descricao"
            v-model="novoAgendamento.descricao"
            v-validate="'required'"
          />
          <span v-show="errors.has('descricao')" class="help-block">Campo obrigatório</span>
        </div>
      </div>
      <div class="col-sm-4 col-lg-3">
        <div :class="{'form-group': true, 'has-error':errors.has('data') }">
          <label for="data">Data</label>
          <input
            v-validate="'required'"
            name="data"
            type="date"
            class="form-control"
            v-model="novoAgendamento.data"
          />
          <span v-show="errors.has('data')" class="help-block">Campo obrigatório</span>
        </div>
      </div>
    </div>
    <div class="text-right mt-20">
      <button class="btn btn-primary" @click="criarAgendamento()">Agendar</button>
    </div>

    <h4 class="mt-40">Agendamentos registrados para esta pessoa</h4>
    <div class="row" style="margin-top:15px">
      <div class="col-sm-12 table-responsive">
        <table
          aria-describedby="example1_info"
          role="grid"
          id="example1"
          class="table table-bordered table-striped"
        >
          <thead>
            <tr role="row">
              <th style="width:auto">Data</th>
              <th style="width:auto">Descrição</th>
              <th style="width:auto">Status</th>
              <th style="width:auto">Log</th>
            </tr>
          </thead>

          <tbody>
            <tr role="row" class="odd" v-for="(item, index) in apiData.data" :key="index">
              <td>{{ item.data | dataFormatada }}</td>
              <td>{{ item.descricao }}</td>
              <td>{{ item.status }}</td>
              <td>
                Registrado em:
                <b>{{ item.created_at | dataHoraFormatada }}</b> por
                <b>{{ item.usuario.name }}</b>
              </td>
            </tr>
          </tbody>
        </table>
        <div class="row">
          <div
            class="col-sm-5"
          >Mostrando {{ this.apiData.from }} até {{ this.apiData.to }} de {{ this.apiData.total }} registros encontrados.</div>
          <div class="col-sm-7" style="text-align:right">
            <laravue-pagination
              :limit="5"
              :data="apiData"
              v-on:pagination-change-page="getDataTable"
            >
              <span slot="prev-nav">&lt; Anterior</span>
              <span slot="next-nav">Próximo &gt;</span>
            </laravue-pagination>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios"; // Cliente para requisição http

export default {
  props: ["pessoaId"],
  data: () => ({
    novoAgendamento: [],
    pessoa: {},
    dados: {},
    apiData: {},
  }),
  mounted() {
    this.getDataTable();
    this.getPessoa(this.pessoaId);
  },
  methods: {
    criarAgendamento() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          let dados = {
            data: this.novoAgendamento.data,
            descricao: this.novoAgendamento.descricao,
            pessoa_id: this.pessoa.id,
          };
          let config = this.$store.getters.getHeaderAuth;
          axios
            .post(
              `${this.$store.state.serverURI}/api/pessoa/createNote`,
              dados,
              config
            )
            .then((response) => {
              console.log(response.data);
              this.getDataTable();
              this.novoAgendamento = [];
              this.$swal({
                type: "success",
                title: "Tudo Certo!",
                showConfirmButton: false,
                timer: 1500,
              });
            })
            .catch((error) => {
              this.$store.commit("throwException", error);
            });
        }
      });
    },
    getDataTable(page) {
      if (typeof page === "undefined") {
        page = 1;
      }
      this.dados.page = page;
      let config = this.$store.getters.getHeaderAuth;
      config.params = this.dados;
      axios
        .get(
          `${this.$store.state.serverURI}/api/pessoa/getNotesByPessoaId/${this.pessoaId}`,
          config
        )
        .then((response) => {
          console.log(response.data);
          this.apiData = response.data;
        })
        .catch((error) => {
          this.$store.commit("throwException", error);
        });
    },
    getPessoa(pessoaId) {
      let config = this.$store.getters.getHeaderAuth;
      axios
        .get(
          `${this.$store.state.serverURI}/api/pessoa/getById/${pessoaId}`,
          config
        )
        .then((response) => {
          console.log(response.data);
          this.pessoa = response.data;
        })
        .catch((error) => {
          this.$store.commit("throwException", error);
        });
    },
  },
  watch: {
    page: function (val) {
      this.getDataTable();
    },
  },
};
</script>
<style scoped>
.p-10 {
  padding: 10px;
}
.mt-20 {
  margin-top: 20px;
}
.mt-40 {
  margin-top: 40px;
}
.fw-600 {
  font-weight: 600;
}
.d-flex {
  display: flex;
}
.aling-flex-end {
  align-items: center;
}
</style>



// WEBPACK FOOTER //
// inadimplenteAgendamento.vue?4f2b669a